// Tremor Raw Divider [v0.0.0]
import React from "react";

import { cx } from "@/lib/tailwind-utils";

interface DividerProps extends React.ComponentPropsWithoutRef<"div"> {
  dividerColor?: string;
}

const Divider = React.forwardRef<HTMLDivElement, DividerProps>(
  ({ className, children, dividerColor, ...props }, forwardedRef) => (
    <div
      ref={forwardedRef}
      className={cx(
        // base
        "mx-auto my-6 flex w-full items-center justify-between gap-3 text-body",
        // text color
        "text-muted-foreground",
        className,
      )}
      {...props}
    >
      {children ? (
        <>
          <div
            className={cx(
              // base
              "h-[1px] w-full",
              // background color
              dividerColor ? dividerColor : "bg-muted",
            )}
          />
          <div className="whitespace-nowrap text-inherit">{children}</div>
          <div
            className={cx(
              // base
              "h-[1px] w-full",
              // background color
              dividerColor ? dividerColor : "bg-muted",
            )}
          />
        </>
      ) : (
        <div
          className={cx(
            // base
            "h-[1px] w-full",
            // backround color
            dividerColor ? dividerColor : "bg-muted",
          )}
        />
      )}
    </div>
  ),
);

Divider.displayName = "Divider";
export default Divider;
